var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.973,
    height: 73.076,
    viewBox: "0 0 72.973 73.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    "data-name": "Rectangle 1931",
    width: 72.973,
    height: 73.076,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10235",
    "data-name": "Group 10235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11142",
    "data-name": "Path 11142",
    d: "M36.62,36.421a3.669,3.669,0,1,0,3.669,3.669,3.67,3.67,0,0,0-3.669-3.669m35.618-8.659a36.683,36.683,0,0,0-71.163,0,35.409,35.409,0,0,0,0,17.318A36.624,36.624,0,0,0,27.849,72,35.153,35.153,0,0,0,45.1,72,36.669,36.669,0,0,0,71.916,45.192a35.864,35.864,0,0,0,0-17.313ZM36.62,7.069A29.36,29.36,0,0,1,63.815,25.414H9.426A29.36,29.36,0,0,1,36.62,7.069M7.268,36.421a34.233,34.233,0,0,1,.249-3.669h7.088V40.09H7.518a34.233,34.233,0,0,1-.249-3.669M25.613,63.615A29.4,29.4,0,0,1,9.426,47.428h8.85a7.341,7.341,0,0,1,7.338,7.338Zm14.676,1.908a34.233,34.233,0,0,1-3.669.249,34.233,34.233,0,0,1-3.669-.249V58.435h7.338ZM40.8,51.1H32.438A14.664,14.664,0,0,0,21.944,40.6V32.752H51.3V40.6A14.663,14.663,0,0,0,40.8,51.1m6.824,12.519v-8.85a7.341,7.341,0,0,1,7.338-7.338h8.85A29.4,29.4,0,0,1,47.627,63.615m18.1-23.525H58.634V32.752h7.088a34.233,34.233,0,0,1,.249,3.669,34.233,34.233,0,0,1-.249,3.669",
    transform: "translate(0.001 0.001)",
    fill: "#152c40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/drive_icon.c2e9c643ffac836882192f6198698976.svg";
export { ForwardRef as ReactComponent };